import { Link } from "react-router-dom";
import { BOOKING_URL } from "@/config/site";

export default function Footer() {
  return (
    <footer className="bg-[#418b86] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src="/images/logo.jpg"
              alt="Clarity Point Counseling"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              A safe, supportive space where healing begins with being truly heard.
            </p>
            <p className="text-white/90 text-base font-light italic leading-snug">
              "Healing begins with<br />one honest conversation."
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2.5">
              {["Individual Counseling", "Anxiety & Stress", "Life Transitions", "Relationship Support"].map((item) => (
                <li key={item}>
                  <Link to="/services" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">About</h4>
            <ul className="space-y-2.5">
              {[
                { label: "Meet the Counselor", path: "/about" },
                { label: "Our Approach", path: "/about" },
                { label: "Philosophy of Care", path: "/about" },
                { label: "Blog", path: "/blog" },
                { label: "FAQ", path: "/contact" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Connect</h4>
            <ul className="space-y-2.5 mb-6">
              <li>
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Schedule a Consultation
                </a>
              </li>
              <li>
                <a href="mailto:rholmes@claritypoint-counseling.com" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  rholmes@claritypoint-counseling.com
                </a>
              </li>
              <li>
                <a href="tel:5085667333" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  508 566 7333
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs">
            &copy; {new Date().getFullYear()} Clarity Point Counseling. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/50 hover:text-white/80 text-xs transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-white/50 hover:text-white/80 text-xs transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
